<template>
  <div class="modal-overlay" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <h3>{{ isEditing ? '编辑任务' : '添加任务' }}</h3>
        <button class="close-btn" @click="closeModal">×</button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="saveTask">
          <div class="form-group">
            <label for="title">任务标题</label>
            <input id="title" v-model="taskForm.title" type="text" placeholder="请输入任务标题" required />
          </div>

          <div class="form-group">
            <label for="description">任务描述</label>
            <textarea id="description" v-model="taskForm.description" placeholder="请输入任务描述"></textarea>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="type">任务类型</label>
              <select id="type" v-model="taskForm.typeId">
                <option value="">请选择类型</option>
                <option v-for="type in store.types" :key="type.id" :value="type.id">
                  {{ type.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label for="cycle">任务周期</label>
              <select id="cycle" v-model="taskForm.cycleId">
                <option value="">请选择周期</option>
                <option v-for="cycle in store.cycles" :key="cycle.id" :value="cycle.id">
                  {{ cycle.name }}
                </option>
              </select>
            </div>
          </div>

          <!-- 起始时间和结束时间 -->
          <div class="form-row">
            <div class="form-group">
              <label for="beginTime">起始时间</label>
              <input id="beginTime" v-model="taskForm.beginTime" type="date" />
            </div>

            <div class="form-group">
              <label for="endTime">结束时间</label>
              <input id="endTime" v-model="taskForm.endTime" type="date" />
            </div>
          </div>

          <!-- 日期点和时间点 -->
          <div class="form-row">
            <div class="form-group">
              <label for="difDate">日期点</label>
              <select id="difDate" v-model="taskForm.difDate">
                <option value="">请选择日期点</option>
                <option value="第一天">第一天</option>
                <option value="第二天">第二天</option>
                <option value="第三天">第三天</option>
                <option value="第四天">第四天</option>
                <option value="第五天">第五天</option>
                <option value="第六天">第六天</option>
                <option value="第七天">第七天</option>
                <option value="最后一天">最后一天</option>
              </select>
            </div>

            <div class="form-group">
              <label for="dayTime">时间点</label>
              <select id="dayTime" v-model="taskForm.dayTime">
                <option value="">请选择时间点</option>
                <option value="0点">0点</option>
                <option value="1点">1点</option>
                <option value="2点">2点</option>
                <option value="3点">3点</option>
                <option value="4点">4点</option>
                <option value="5点">5点</option>
                <option value="6点">6点</option>
                <option value="7点">7点</option>
                <option value="8点">8点</option>
                <option value="9点">9点</option>
                <option value="10点">10点</option>
                <option value="11点">11点</option>
                <option value="12点">12点</option>
                <option value="13点">13点</option>
                <option value="14点">14点</option>
                <option value="15点">15点</option>
                <option value="16点">16点</option>
                <option value="17点">17点</option>
                <option value="18点">18点</option>
                <option value="19点">19点</option>
                <option value="20点">20点</option>
                <option value="21点">21点</option>
                <option value="22点">22点</option>
                <option value="23点">23点</option>
              </select>
            </div>
          </div>

          <!-- 进度相关字段 -->
          <div class="form-row">
            <div class="form-group">
              <label for="currentCount">当前进度</label>
              <input id="currentCount" v-model.number="taskForm.current_count" type="number" min="0" />
            </div>

            <div class="form-group">
              <label for="targetCount">目标进度</label>
              <input id="targetCount" v-model.number="taskForm.target_count" type="number" min="0" />
            </div>
          </div>

          <!-- 价值和绑定事件 -->
          <div class="form-row">
            <div class="form-group">
              <label for="worth">任务价值</label>
              <input id="worth" v-model.number="taskForm.worth" type="number" min="0" step="0.01" />
            </div>

            <div class="form-group">
              <label for="bindEvent">绑定事件</label>
              <select id="bindEvent" @change="handleBindEventChange">
                <option value="">请选择绑定事件</option>
                <option value="会议提醒">会议提醒</option>
                <option value="邮件通知">邮件通知</option>
                <option value="短信提醒">短信提醒</option>
                <option value="系统通知">系统通知</option>
                <option value="自定义">自定义</option>
              </select>
              <input id="bindEventInput" v-model="taskForm.bind_event" type="text" placeholder="请输入绑定事件" />
            </div>
          </div>

          <!-- 任务状态 -->
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="taskForm.is_active" />
              任务活跃状态（取消勾选表示已删除）
            </label>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn secondary" @click="closeModal">
              取消
            </button>
            <button type="submit" class="btn primary">
              {{ isEditing ? '更新' : '添加' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useTodoStore } from '../stores/todoStore.js'
import TodoService from '@/services/todoService.js'

export default {
  name: 'TaskModal',
  props: {
    task: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const store = useTodoStore()

    const isEditing = computed(() => !!props.task)

    const taskForm = ref({
      title: '',
      description: '',
      typeId: '',
      cycleId: '',
      beginTime: '',
      endTime: '',
      difDate: '',
      dayTime: '',
      is_active: true,
      current_count: 0,
      target_count: 0,
      worth: 0,
      bind_event: ''
    })

    // 监听任务属性变化，更新表单
    watch(
      () => props.task,
      (newTask) => {
        if (newTask) {
          taskForm.value = {
            title: newTask.title || '',
            description: newTask.description || '',
            typeId: newTask.typeId || '',
            cycleId: newTask.cycleId || '',
            beginTime: newTask.beginTime || '',
            endTime: newTask.endTime || '',
            difDate: newTask.difDate || '',
            dayTime: newTask.dayTime || '',
            is_active: newTask.is_active !== undefined ? newTask.is_active : true,
            current_count: newTask.current_count !== undefined ? newTask.current_count : 0,
            target_count: newTask.target_count !== undefined ? newTask.target_count : 0,
            worth: newTask.worth !== undefined ? newTask.worth : 0,
            bind_event: newTask.bind_event || ''
          }
        } else {
          taskForm.value = {
            title: '',
            description: '',
            typeId: '',
            cycleId: '',
            beginTime: '',
            endTime: '',
            difDate: '',
            dayTime: '',
            is_active: true,
            current_count: 0,
            target_count: 0,
            worth: 0,
            bind_event: ''
          }
        }
      },
      { immediate: true }
    )

    const closeModal = () => {
      emit('close')
    }

    // 处理绑定事件下拉列表变化
    const handleBindEventChange = (event) => {
      const selectedValue = event.target.value
      if (selectedValue && selectedValue !== '自定义') {
        taskForm.value.bind_event = selectedValue
      }
    }

    const saveTask = async () => {
      try {
        if (isEditing.value) {
          // 更新现有任务
          const data = {
            todo_id: props.task.id,
            title: taskForm.value.title,
            category: taskForm.value.description,
            typeid: taskForm.value.typeId,
            cycleid: taskForm.value.cycleId,
            begin_time: taskForm.value.beginTime,
            end_time: taskForm.value.endTime,
            dif_date: taskForm.value.difDate,
            day_time: taskForm.value.dayTime,
            is_active: taskForm.value.is_active,
            current_count: taskForm.value.current_count,
            target_count: taskForm.value.target_count,
            worth: taskForm.value.worth,
            bind_event: taskForm.value.bind_event
          }

          const response = await TodoService.updateTodoItem(data)
          if (response.status === 'ok') {
            // 更新store中的任务
            const updatedTasks = store.tasks.map(t =>
              t.id === props.task.id ? {
                ...t,
                title: response.todo_item.title,
                description: response.todo_item.category,
                completed: response.todo_item.is_completed,
                typeId: response.todo_item.typeid,
                cycleId: response.todo_item.cycleid,
                beginTime: response.todo_item.begin_time,
                endTime: response.todo_item.end_time,
                difDate: response.todo_item.dif_date,
                dayTime: response.todo_item.day_time,
                is_active: response.todo_item.is_active,
                current_count: response.todo_item.current_count,
                target_count: response.todo_item.target_count,
                worth: response.todo_item.worth,
                bind_event: response.todo_item.bind_event,
                createdAt: response.todo_item.created_at,
                updatedAt: response.todo_item.updated_at
              } : t
            )
            store.updateTasks(updatedTasks)
            console.log('任务更新成功')

            // 如果任务有价值且已完成，更新用户价值
            if (response.todo_item.worth > 0 && response.todo_item.is_completed) {
              try {
                const worthData = {
                  todo_id: props.task.id,
                  is_completed: response.todo_item.is_completed,
                  worth_change: response.todo_item.worth
                }

                const worthResponse = await TodoService.updateWorth(worthData)
                if (worthResponse.status === 'ok') {
                  console.log('价值更新成功:', worthResponse.message)
                  // 更新用户总价值
                  try {
                    const userWorthResponse = await TodoService.getUserWorth();
                    if (userWorthResponse.status === 'ok') {
                      store.updateUserWorth(userWorthResponse.current_worth);
                    }
                  } catch (error) {
                    console.error('获取用户价值失败:', error);
                  }
                } else {
                  console.error('价值更新失败:', worthResponse.message)
                }
              } catch (worthError) {
                console.error('价值更新异常:', worthError)
              }
            }
          }
        } else {
          // 添加新任务
          const data = {
            title: taskForm.value.title,
            category: taskForm.value.description,
            typeid: taskForm.value.typeId,
            cycleid: taskForm.value.cycleId,
            begin_time: taskForm.value.beginTime,
            end_time: taskForm.value.endTime,
            dif_date: taskForm.value.difDate,
            day_time: taskForm.value.dayTime,
            is_active: taskForm.value.is_active,
            current_count: taskForm.value.current_count,
            target_count: taskForm.value.target_count,
            worth: taskForm.value.worth,
            bind_event: taskForm.value.bind_event
          }

          const response = await TodoService.addTodoItem(data)
          if (response.status === 'ok') {
            // 添加新任务到store
            const newTask = {
              id: response.todo_item.id,
              title: response.todo_item.title,
              description: response.todo_item.category,
              completed: response.todo_item.is_completed,
              typeId: response.todo_item.typeid,
              cycleId: response.todo_item.cycleid,
              beginTime: response.todo_item.begin_time,
              endTime: response.todo_item.end_time,
              difDate: response.todo_item.dif_date,
              dayTime: response.todo_item.day_time,
              createdAt: response.todo_item.created_at,
              updatedAt: response.todo_item.updated_at,
              is_active: response.todo_item.is_active,
              current_count: response.todo_item.current_count,
              target_count: response.todo_item.target_count,
              worth: response.todo_item.worth,
              bind_event: response.todo_item.bind_event
            }
            store.updateTasks([...store.tasks, newTask])
            console.log('任务添加成功:', response.todo_item)
          }
        }
        closeModal()
      } catch (error) {
        console.error('保存任务失败:', error)
      }
    }

    return {
      store,
      isEditing,
      taskForm,
      closeModal,
      handleBindEventChange,
      saveTask
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  box-sizing: border-box;
}

.form-group textarea {
  min-height: 100px;
  resize: vertical;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn.primary {
  background: #42b983;
  color: white;
}

.btn.primary:hover {
  background: #359c6d;
}

.btn.secondary {
  background: #f0f0f0;
  color: #333;
}

.btn.secondary:hover {
  background: #e0e0e0;
}
</style>